import React, { useMemo } from 'react';
import ModalConfirm from '@keyslabor/shared/ui/ModalConfirm';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard.ts';
import { Button, Input } from '@keyslabor/shared/ui';

export function isInAppBrowser() {
  const ua = navigator.userAgent;
  const isFacebook = ua.includes('FBAN') || ua.includes('FBAV');
  const isInstagram = ua.includes('Instagram');
  return isFacebook || isInstagram;
}

const InAppBrowserBlock = () => {
  const [textCopied, copyFn] = useCopyToClipboard();
  const handleCopyUrl = () => {
    copyFn(location.href);
  };
  const { isIOS, isAndroid } = useMemo(() => {
    return {
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
      isAndroid: navigator.userAgent.toLowerCase().indexOf('android') > -1,
    };
  }, []);

  let message = '';

  if (isIOS) {
    message =
      'iOS: Tap the "… " menu in the top-right, then choose "Open in Browser" (or "Open in Safari").';
  } else if (isAndroid) {
    message =
      'Android: Tap the "⋮" menu in the top-right, then choose "Open in browser" or "Open in Chrome".';
  } else {
    message = 'Tap the browser menu and choose "Open in browser".';
  }
  const inApp = isInAppBrowser();

  if (!inApp) {
    return null;
  }

  return (
    <ModalConfirm
      key="inAppBrowserBlock"
      show
      drawer={false}
      customDesktopWidth={'auto'}
    >
      <div className="mt-3 font-semibold text-base max-w-xs text-center mb-3">
        It looks like you're using an in-app browser. To use the camera
        correctly during interview, please open this page in your device's
        browser.
      </div>
      <div className="mt-3 font-semibold text-base max-w-xs text-center mb-3">
        {message}
      </div>
      {isIOS ? (
        <a href={location.href} target="_blank" rel="noreferrer">
          <Button kind="large" css={'text-transform: unset;'}>
            Open in Safari
          </Button>
        </a>
      ) : (
        <>
          <Input
            variant={'outlined'}
            readOnly
            value={location.href}
          />
          <Button
            kind="large"
            onClick={handleCopyUrl}
            css={'text-transform: unset; margin-top: 16px;'}
          >
            {textCopied ? 'Link Copied' : 'Copy Interview Link'}
          </Button>
        </>
      )}
    </ModalConfirm>
  );
};

export default InAppBrowserBlock;
